import svgUrl from "ni:svgr;BPKkTfZxCTbC8cARgIWsQd2F82LCjKvIYhwsfey1lPI";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const SvgChevronDown = props => <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.646 3.646a.5.5 0 0 1 .708 0L6 7.293l3.646-3.647a.5.5 0 1 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708Z" fill="currentColor" /></svg>;
const Memo = memo(SvgChevronDown);
export { Memo as ReactComponent };